import type React from "react";

export function ModuleShell({
  eyebrow,
  title,
  description,
  meta,
  children,
}: {
  eyebrow: string;
  title: string;
  description?: string;
  meta?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <div className="p-2.5 sm:p-3 space-y-3">
        <header className="glass rounded-xl p-3 sm:p-4 flex flex-wrap items-start gap-3">
          <div className="min-w-0 flex-1">
            <div className="font-mono text-[9px] sm:text-[10px] uppercase tracking-[0.25em] sm:tracking-[0.3em] text-cyan">{eyebrow}</div>
            <h1 className="mt-1 font-display text-xl sm:text-2xl">{title}</h1>
            {description && <p className="mt-1 max-w-3xl text-sm text-muted-foreground">{description}</p>}
          </div>
          {meta && <div className="w-full min-w-0 sm:w-auto">{meta}</div>}
        </header>
        {children}
    </div>
  );
}

export function StatTile({ label, value, tone = "cyan" }: { label: string; value: string | number; tone?: "cyan" | "amber" | "success" | "danger" }) {
  const toneClass = tone === "amber" ? "text-amber" : tone === "success" ? "text-success" : tone === "danger" ? "text-danger" : "text-cyan";
  return (
    <div className="rounded-md border border-panel-border bg-background/40 p-3">
      <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">{label}</div>
      <div className={`mt-1 font-display text-2xl ${toneClass}`}>{value}</div>
    </div>
  );
}